export function LogoMark({ className = "h-9 w-9" }) {
  return (
    <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
      <rect width="64" height="64" rx="4" fill="#4A1942" />
      <ellipse cx="32" cy="31" rx="13" ry="18" fill="none" stroke="#D9B46A" strokeWidth="5" transform="rotate(18 32 31)" />
      <path d="M40 12c4-3 9-2 10 1" fill="none" stroke="#F1DBA6" strokeWidth="2.4" strokeLinecap="round" />
    </svg>
  );
}

export function Logo() {
  return (
    <span className="flex items-center gap-2 sm:gap-3">
      <img src="/brand/logo-mark.png" alt="" aria-hidden="true" data-testid="logo-mark-img" className="h-9 w-9 rounded-[3px] object-cover sm:h-10 sm:w-10" />
      <span className="font-display text-lg tracking-[0.18em] text-[var(--parchment)] sm:text-xl sm:tracking-[0.28em]">
        <span className="text-[var(--gold)]">O</span>ZENTYA
      </span>
    </span>
  );
}
